import { useHistory } from 'react-router-dom'

import { getRenewalPlanPeriod } from 'core'
import { BenefitDesignStatus } from 'core/domain/benefit/benefitDesignStatus'

import { Button, Card, Col, Row, Skeleton } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'
import { ROUTE_PATHS } from 'common/routePaths'

function PerksAdminCountdownTimer() {
  const history = useHistory()

  const { data: renewalPlanPeriod, isLoading: isRenewalPlanPeriodLoading } = useQueryRequestV2({
    initialState: null,
    queryFn: () => getRenewalPlanPeriod(),
  })

  return (
    <Skeleton loading={isRenewalPlanPeriodLoading}>
      {(renewalPlanPeriod === null || renewalPlanPeriod?.status !== BenefitDesignStatus.Signed) && (
        <Card style={{ backgroundColor: '#E6FFFF', border: '1px solid #8DF3FC' }}>
          <Row gutter={16}>
            <Col>
              <h4>You’ve started your benefit renewal - keep going!</h4>
              <div>
                <p>You can reconfigure your WorkPerks benefit design for your upcoming plan period. </p>
                <p>
                  If you begin making changes, and do not complete the benefit renewal process, the system will
                  automatically launch your benefit and send a notification to your employees.
                </p>
              </div>
              <Row gutter={16} className="mb-24 mt-24">
                <Col>
                  <Button
                    type="primary"
                    onClick={() => {
                      history.push(ROUTE_PATHS.RENEWAL_TASKS)
                    }}
                  >
                    In Progress - Continue where you left off
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      )}
    </Skeleton>
  )
}

export default PerksAdminCountdownTimer
